import { Skeleton, Stack } from "@mui/material";
import { CardListSkeleton } from "Components/Shared/CardsList/CardListSkeleton";

type Props = {
  isReadOnly?: boolean;
};

export const ControlledCardsListSkeleton = ({ isReadOnly }: Props) => (
  <Stack alignItems="center">
    <CardListSkeleton />
    {!isReadOnly && <Skeleton height={40} width="30%" variant="text" />}
  </Stack>
);
